export default __webpack_public_path__ + "static/InfillOrdinances-dc9867a384f333597211248f07457d83.jpg";